import { gql } from '@apollo/client';

export const GET_WORKSPACE_FORMS = gql`
  query GetWorkspaceForms($id: ID!) {
    workspaceForms: getWorkspaceForms(id: $id) {
      id
      name
      version
      published
      webCollection
      submissionsPerPeriod
      url
      users {
        id
        user {
          id
          firstName
          lastName
          funder {
            id
            name
          }
          institution {
            id
            name
          }
          serviceProvider {
            id
            name
          }
        }
        formRole {
          id
          name
        }
      }
      respondents {
        id
        user {
          id
          firstName
          lastName
          funder {
            id
            name
          }
          institution {
            id
            name
          }
          serviceProvider {
            id
            name
          }
        }
        formRole {
          id
          name
        }
      }
      dueDates {
        id
        date
        periodDate
      }
      template {
        id
        name
      }
    }
  }
`;
